/**
 * Shallow-equality check used by React.memo for comments panel rows.
 */
export const arePropsShallowEqual = <P extends Record<string, unknown>>(
	prev: Readonly<P>,
	next: Readonly<P>,
): boolean => {
	if (prev === next) {
		return true;
	}

	const prevKeys = Object.keys(prev);
	const nextKeys = Object.keys(next);

	if (prevKeys.length !== nextKeys.length) {
		return false;
	}

	for (const key of prevKeys) {
		if (!Object.prototype.hasOwnProperty.call(next, key)) {
			return false;
		}
		if (prev[key] !== next[key]) {
			return false;
		}
	}

	return true;
};
